/**
 * Backend (main schema) can return null for optional columns.
 * Use normalizeProduct() in services so components always get filled fields.
 */
export interface Product {
  id: number;
  name: string;
  color?: string;
  quantity: number;
  brand?: string;
  code?: string;
  purchaseDate?: string;
  /** Alış fiyatı (backend: purchase_price) */
  unitPrice: number;
  /** Satış fiyatı (backend: sale_price) */
  retailPrice: number;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

/** API'den gelen product (null alanlar olabilir) → ekranda kullanılacak Product */
export function normalizeProduct(p: Partial<Product> & { id: number }): Product {
  return {
    id: p.id,
    name: p.name ?? '',
    color: p.color,
    quantity: p.quantity ?? 0,
    brand: p.brand,
    code: p.code,
    purchaseDate: p.purchaseDate,
    unitPrice: typeof p.unitPrice === 'number' ? p.unitPrice : Number(p.unitPrice) ?? 0,
    retailPrice: typeof p.retailPrice === 'number' ? p.retailPrice : Number(p.retailPrice) ?? 0,
    description: p.description,
    createdAt: p.createdAt,
    updatedAt: p.updatedAt,
  };
}

export interface ProductFormData {
  name: string;
  color?: string;
  quantity: number;
  brand?: string;
  code?: string; // Backend'de "code" olarak adlandırılmış
  purchaseDate?: string;
  unitPrice: number; // Backend'de "unitPrice" = Alış Fiyatı (cost/purchase price)
  retailPrice: number; // Backend'de "retailPrice" = Satış Fiyatı (selling price)
  description?: string;
}

export interface PageResponse<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}

